<template>
  <div
   class="pa-message-additional-question-box-wrapper"
   :class="additionalClass"
   v-if="couldVisible"
  >
    <div class="pa-attension-message">御注意事項：回答結果は他者に開示される可能性有</div>
    <div
    class="pa-message-additional-box pa-message-additional-question-box"
    >
      <p class="title">-&nbsp;リリカからの問掛&nbsp;-</p>
      <p class="question">{{questionParameters.question}}</p>
      <template v-if="questionParameters.type === 'select'">
        <ul class="answers">
          <li v-for="(item, index) in questionParameters.selections" :key="index">
            <button
            class="button"
            :disabled="answerButtonDisabled"
            :class="answerButtonClass"
            @click.prevent="handleSelectQuestion(item)"
            >{{item}}</button>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    parameters : {
      default: null
    },

    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    }
  },
  
  data(){
    return {
      isFormLoading       : false,

      questionParameters  : null,
      
      couldVisible        : false,

      formSet             : {},
      options             : {
        questionName  : '',
        questionValue : ''
      },

      answerButtonDisabled  : false,
      answerButtonClass     : {
        'is-loading'  : false
      },

      additionalClass       : {
        'is-disabled' : false
      }
    };
  },

  watch : {
    parameters : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;

        this.questionParameters = JSON.parse(this.parameters);
      },
      immediate: true
    },

    questionParameters : {
      handler(data){
        if(typeof data.question !== 'undefined'){
          this.couldVisible = true;
        }else{
          this.couldVisible = false;
        }
      },
      immediate: true,
      deep: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isFormLoading = true;
        }else{
          this.isFormLoading = false;
        }
      }
    },

    isFormLoading : {
      handler(value){
        this.isDisabledFormFields = value;
        
        this.answerButtonDisabled = value;
        this.answerButtonClass['is-loading'] = value;
      }
    },

    isDisabled : {
      handler(value){
        this.answerButtonDisabled = value;
        this.additionalClass['is-disabled'] = value;
      }
    }

    // isDisabledFormFields  : {
    //   handler(value){
    //     if(value === true){
    //       this.disabledFields();
    //     }else{
    //       this.unDisabledFields();
    //     }
    //   },
    //   immediate: true
    // },
  },

  methods : {
    async handleSelectQuestion(item){
      this.options.questionName  = this.questionParameters.slug;
      this.options.questionValue = item;

      this.$emit('onSubmit', this.formSet, this.options);
    },

    handleCancel(){
      this.$emit('onCancel');
    }
  }
}
</script>

<style lang="scss">
.pa-message-set{
  .content{
    .message-balloon{
      .pa-attension-message{
        font-size:.7rem;
        background-color: #D2B478;
        color:#5f5b5b;
        border-radius: 6px;
        padding:5px 6px;
        text-align: center;
        margin:6px auto 8px;
      }

      .pa-message-additional-question-box{
        background-color:#DFAAE1;
        border-radius: 6px;
        padding:12px 10px 10px;

        p.title{
          font-size:14px;
          text-align: center;
          margin:0 0 .7rem;
          color:#363636;
        }

        p.question{
          background-color:#E08CE3;
          border-radius:12px;
          text-align: center;
          padding:4px 4px 2px;
          font-size:.9rem;
          color:#363636;
        }

        ul.answers{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          list-style-type: none;
          margin:14px auto 4px;
          width:90%;

          li{
            margin-top:0 !important;
            width:50%;

            button.button{
              display: block;
              border:0;
              background-color:#8AA0DB;
              border-radius: 12px;
              width:95%;
              margin:0 auto;
              padding:2px 0;
              height: inherit;
              font-size:.9rem;
              color:#363636;
            }
          }
        }
      }

      .pa-message-additional-question-box-wrapper{
        &.is-disabled{
          opacity:.8;
          
          p.title{
            color:#686868;
          }

          p.question{
            color:#686868;
          }

          ul.answers{
            li{
              button.button{
                color:#686868;
              }
            }
          }
        }
      }
    }
  }
}
</style>